export default __webpack_public_path__ + "static/media/ISQ-Logo.1128cbb9.jpg";